import { useContext } from '@utils/context'
import { initMixpanel } from '@utils/mixpanelClient'
import TimeAgo from 'javascript-time-ago'
import en from 'javascript-time-ago/locale/en.json'
import mixpanel from 'mixpanel-browser'
import { useEffect, useLayoutEffect, useMemo, useRef } from 'react'

export const useInitMixpanel = () => {
  const [rootState] = useContext()
  const subscription = rootState?.ShopReducer?.subscription as
    | {
        shop_id?: number | string
        type_app?: string
      }
    | undefined

  const shopId = useMemo(() => {
    if (!subscription?.shop_id) return null
    return String(subscription.shop_id)
  }, [subscription?.shop_id])

  const planName = subscription?.type_app || null

  const thirdPartyInitRef = useRef(false)
  useLayoutEffect(() => {
    if (thirdPartyInitRef.current) return
    thirdPartyInitRef.current = true
    TimeAgo.addDefaultLocale(en)
    initMixpanel()
  }, [])

  const mixpanelIdentityRef = useRef<string | null>(null)
  useEffect(() => {
    if (!shopId) return
    if (mixpanelIdentityRef.current === shopId) return
    mixpanelIdentityRef.current = shopId

    try {
      mixpanel.identify(shopId)
      if (planName) {
        mixpanel.people.set({
          pricing: planName,
        })
      }
    } catch {
      /* noop */
    }
    
  }, [planName, shopId])
}
